const blockMediaInteraction = (event: Event) => {
	const target = event.target;

	if (
		!(target instanceof HTMLImageElement || target instanceof HTMLVideoElement)
	) {
		return;
	}

	event.preventDefault();
};

const setMediaNonInteractive = (root: ParentNode = document) => {
	root.querySelectorAll('img, video').forEach((element) => {
		element.setAttribute('draggable', 'false');
	});
};

export const setupMediaProtection = () => {
	setMediaNonInteractive();

	const mediaObserver = new MutationObserver((mutations) => {
		mutations.forEach(({ addedNodes }) => {
			addedNodes.forEach((node) => {
				if (!(node instanceof Element)) {
					return;
				}

				if (node.matches('img, video')) {
					node.setAttribute('draggable', 'false');
					return;
				}

				setMediaNonInteractive(node);
			});
		});
	});

	mediaObserver.observe(document.documentElement, {
		childList: true,
		subtree: true,
	});

	document.addEventListener('dragstart', blockMediaInteraction);
	document.addEventListener('selectstart', blockMediaInteraction);
};
